import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=60885f30&"
import script from "./TabGeneral.vue?vue&type=script&lang=ts&"
export * from "./TabGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports